import React, { useCallback } from 'react';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { DrawerNavigationProp } from '@react-navigation/drawer';
import { StackNavigationProp } from '@react-navigation/stack';

import Back from 'assets/images/svgs/ico_arrow_left.svg';

import { LANGUAGE_KEYS } from 'config/languageKeys';

import { RouteNavigationParams } from 'router/types';

import { selectScreenReaderEnabled } from 'store/config/selectors';
import {
    selectPlayerConfig,
    selectSpotlightVideoVisible,
} from 'store/player/selectors';

import { HEADER_HEIGHT } from 'utils/hooks/useHeaderHeight';
import { isAndroid15 } from 'utils/responsiveness';

import SvgButton from 'components/CustomButtons/SvgButton';

import { svgButtonStyle } from '../constants';
import styles from './styles';

type Props = {
    navigation:
        | StackNavigationProp<
              RouteNavigationParams,
              keyof RouteNavigationParams
          >
        | DrawerNavigationProp<any>;
    detailsLoading: boolean;
};

const {
    ACCESSIBILITY: {
        DETAIL_PAGE: { ACCSESSIBILITY_DETAIL_PAGE_BACK },
    },
} = LANGUAGE_KEYS;

function DetailsNavigationHeaderLeft({ navigation, detailsLoading }: Props) {
    const { t } = useTranslation();
    const { visible: playerVisible } = useSelector(selectPlayerConfig);
    const spotlightPlayerVisible = useSelector(selectSpotlightVideoVisible);
    const screenReaderEnabled = useSelector(selectScreenReaderEnabled);

    const handlePress = useCallback(() => {
        (
            navigation as StackNavigationProp<
                RouteNavigationParams,
                keyof RouteNavigationParams
            >
        ).pop();
    }, [navigation]);

    return (
        <SvgButton
            style={[
                styles.root,
                isAndroid15 &&
                    screenReaderEnabled && {
                        marginTop: HEADER_HEIGHT / 2,
                    },
            ]}
            Svg={Back}
            svgStyle={svgButtonStyle}
            onPress={handlePress}
            accessibilityLabel={t(ACCSESSIBILITY_DETAIL_PAGE_BACK)}
            importantForAccessibility={
                playerVisible || spotlightPlayerVisible || detailsLoading
                    ? 'no-hide-descendants'
                    : 'auto'
            }
            accessibilityElementsHidden={
                playerVisible || spotlightPlayerVisible || detailsLoading
            }
        />
    );
}

export default DetailsNavigationHeaderLeft;
